import {
  FETCH_ALL_CHAIR_RENTALS,
  FETCH_CHAIR_RENTAL,
  FETCH_CHAIR_RENTAL_PAYMENT_HISTORY,
  FETCH_SINGLE_CHAIR_RENTAL_PAYMENT,
} from './constants';
import Http from '../../../http';

const getAllChairRentals = chairRentals => ({
  type: FETCH_ALL_CHAIR_RENTALS,
  payload: chairRentals,
});

const getChairRental = chairRental => ({
  type: FETCH_CHAIR_RENTAL,
  payload: chairRental,
});

const getChairRentalPaymentHistory = chairRentalPayments => ({
  type: FETCH_CHAIR_RENTAL_PAYMENT_HISTORY,
  payload: chairRentalPayments,
});

const getSingleChairRentalPayment = chairRentalPayment => ({
  type: FETCH_SINGLE_CHAIR_RENTAL_PAYMENT,
  payload: chairRentalPayment,
});

export const saveChairRental = (barberId, data) => dispatch =>
  Http.post(`/barber/${barberId}/booth-rental`, data).then(chairRental =>
    dispatch(getChairRental(chairRental))
  );

export const getAllShopBarbersChairRental = shopId => dispatch =>
  Http.get(`/shop/${shopId}/booth-rental`).then(
    chairRentals => dispatch(getAllChairRentals(chairRentals))
  );

export const getSingleChairRental = barberId => dispatch =>
  Http.get(`/barber/${barberId}/booth-rental`).then(chairRental =>
    dispatch(getChairRental(chairRental))
  );

export const chargeChairRentalPayment = (
  barberId,
  paymentId,
  body = {},
) => dispatch =>
  Http.post(`/barber/${barberId}/booth-rental/payment/${paymentId}/charge`, body)
    .then(() => dispatch(getSingleChairRental(barberId)));

export const refundChairRentalPayment = (barberId, paymentId) => dispatch =>
  Http.post(`/barber/${barberId}/booth-rental/payment/${paymentId}/refund`)
    .then(refundedPayment => dispatch(getSingleChairRentalPayment(refundedPayment)));

export const fetchChairRentalPaymentHistory = (barberId, month) => dispatch =>
  Http.get(`/barber/${barberId}/booth-rental/payment/${month}`)
    .then(paymentHistory => dispatch(getChairRentalPaymentHistory(paymentHistory)));
